<template>
  <div>
    <b-form-select
      v-if="getElement(element) === elementType.SELECT"
      v-model="element.value"
      :disabled="element.type.options.length <= 1"
    >
      <b-form-select-option
        v-for="option in element.type.options"
        :key="option"
        :value="option"
      >
        {{ option }}
      </b-form-select-option>
    </b-form-select>
    <ValidationProvider
      v-slot="{touched, valid, errors}"
      :name="element.label"
      :rules="isUsername(element) ? 'required|email' : null"
    >
      <b-input-group>
        <b-form-input
          v-if="getElement(element) === elementType.INPUT"
          v-model="element.value"
          :state="!touched || !isUsername(element) ? null : valid"
          :placeholder="getInputType(element) === elementType.PASSWORD ? '**************' : ''"
          :type="showPassword ? 'text' : getInputType(element)"
        />
        <b-input-group-append
          v-if="getInputType(element) === elementType.PASSWORD"
        >
          <b-button
            variant="primary"
            @mousedown="showPassword = true"
            @mouseup="showPassword = false"
          >
            <font-awesome-icon icon="eye" />
          </b-button>
        </b-input-group-append>
      </b-input-group>
      <span class="error_message">{{ errors[0] }}</span>
    </ValidationProvider>

    <b-form-checkbox
      v-if="getElement(element) === elementType.CHECKBOX"
      v-model="element.value"
      required
    >
      {{ element.label }}
    </b-form-checkbox>
  </div>
</template>

<script>
export default {
  name: 'SystemSettingsFields',
  props: [
    'element',
    'elementType',
    'getElement',
    'getInputType',
  ],
  data() {
    return {
      showPassword: false,
    };
  },
  methods: {
    isUsername(el) {
      return el.label === 'Username';
    },
  },
};
</script>
<style scoped lang="scss">
.form-control:valid.form-control.is-valid {
  border: 1px solid #132f5b;
  background-image: none;
  &:focus {
    box-shadow: 0 0 0 0.2rem rgba(19, 47, 91, 0.25);
  }
}
.error_message {
  position: absolute;
  margin-top: 2px;
  font-size: 10px;
  color: red;
}
</style>